import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { ElectronicProcessPaginationChange } from '@models/planning/electronic-process-pagination.model'

/** "Documento | folha inicial antes → depois | total antes → depois" de uma simulação ou aplicação (spec 002, RF 14). */
@Component({
	selector: 'app-electronic-process-pagination-changes',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `
		<div class="table-responsive">
			<table class="table table-sm align-middle mb-0 small">
				<thead>
					<tr>
						<th>Documento ou anexo</th>
						<th class="text-end">Folha inicial</th>
						<th class="text-end">Páginas</th>
					</tr>
				</thead>
				<tbody>
					@for (change of changes; track $index) {
						<tr>
							<td>{{ change.label || 'Arquivo' }}</td>
							<td class="text-end text-nowrap">
								<span [class.text-muted]="change.iniBefore === change.iniAfter">
									{{ change.iniBefore ?? '—' }} → {{ change.iniAfter ?? '—' }}
								</span>
							</td>
							<td class="text-end text-nowrap">
								<span [class.fw-700]="change.totalBefore !== change.totalAfter">
									{{ change.totalBefore ?? '—' }} → {{ change.totalAfter ?? '—' }}
								</span>
							</td>
						</tr>
					}
				</tbody>
			</table>
		</div>
	`,
	standalone: false
})
export class ElectronicProcessPaginationChangesComponent {
	@Input() changes: ElectronicProcessPaginationChange[] | null = []
}
